import {parse} from 'qs'
import {createProjectModel} from 'company-management/utils/project-model'
import {query, create, modify, remove, queryTree} from './service'

const model = createProjectModel({
    projectNamespace: 'admin',

    state: {
        list: [],
        tree: [],
        createModal: false,
        modifyModal: false,
        record: {},
    },

    effects: {
        *query({callback}, {call, put}) {
            const data = yield call(query)
            if (data && data.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        list: data.data,
                    },
                })
                callback && callback(data.data)
            }
        },
        *queryTree({callback}, {call, put}) {
            const data = yield call(queryTree)
            if (data && data.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        tree: data.data,
                    },
                })
                callback && callback(data.data)
            }
        },
        *create({payload}, {call, put}) {
            const {data} = yield call(create, parse(payload))
            if (data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        createModal: false,
                    },
                })
                yield put({
                    type: 'query',
                    payload: {},
                })
            }
        },
        *modify({payload}, {call, put}) {
            const {data} = yield call(modify, payload)
            if (data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        modifyModal: false,
                    },
                })
                yield put({
                    type: 'query',
                    payload: {},
                })
            }
        },
        *remove({payload}, {call, put}) {
            const {meta} = yield call(remove, parse(payload))
            if (meta && meta.code === 200) {
                yield put({
                    type: 'query',
                    payload: {},
                })
            }
        },
    },

    reducers: {
        setProperty(state, action) {
            return {...state, ...action.payload}
        },
    },
})

export default model
